import React from 'react';
import { Star } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import styles from './AdminProductList.module.css';
import favBtn from '@/ui/assets/icons/favBtn.svg';
import { getAdminProductDetail } from '@/utils/routeHelpers';

const calculateAverageRating = (comments) => {
    if (!comments || comments.length === 0) return 0;
    const totalStars = comments.reduce((acc, c) => acc + Number(c.stars_given || 0), 0);
    return totalStars / comments.length;
};

/**
 * AdminProductList Component
 * Renders products in vertical cards with image on left
 * and description on right.
 */
function AdminProductList({ products }) {

    const navigate = useNavigate();

    if (!products || products.length === 0) {
        return (
            <div className={styles.loadingState}>
                <p>No se encontraron productos...</p>
            </div>
        );

    }

    return (
        <main className={styles.productGrid}>

            {products.map((product) => {
                const average = calculateAverageRating(product.comments);

                const isActiveProduct = product.is_active !== false;

                const handleCardClick = () => {
                    try {
                        localStorage.setItem('admin_selected_product_id', product.id);
                    } catch (error) {
                        console.error("Error guardando el ID en localStorage:", error);
                    }

                    navigate(getAdminProductDetail(product.id), {
                        state: product
                    });
                };

                return (
                    <div
                        className={styles.productCard}
                        key={product.id}
                        onClick={handleCardClick}
                        style={{ cursor: 'pointer' }}
                    >

                        {/* IMAGE */}
                        <div className={styles.imageContainer}>
                            <img
                                src={product.image_url}
                                alt={product.name}
                            />
                        </div>

                        {/* INFO */}
                        <div className={styles.productInfo}>

                            {/* STATUS */}
                            <div className={styles.productStatus}>
                                <span className={styles.statusBadge}>
                                    <span className={`${styles.statusDot} ${isActiveProduct ? styles.dotActive : styles.dotInactive}`}></span>
                                    {isActiveProduct ? "Activo" : "Inactivo"}
                                </span>
                            </div>

                            {/* TITLE */}
                            <h3 className={styles.productTitle}>
                                {product.name || "Producto sin nombre"}
                            </h3>

                            {/* PRICE */}
                            <span className={styles.price}>
                                {Number(product.price || 0).toLocaleString('es-AR')} COP
                            </span>

                            {/* META */}
                            <div className={styles.productMeta}>

                                {/* RATING */}
                                <div className={styles.rating}>
                                    <Star
                                        size={14}
                                        color="#FFB84D"
                                        fill="#FFB84D"
                                    />

                                    <span className={styles.ratingNumber}>
                                        {average > 0 ? average.toFixed(1) : (product.rating || "0")}
                                    </span>
                                </div>

                                {/* Divider */}
                                <span className={styles.metaDivider}></span>

                                {/* LIKES */}
                                <div className={styles.likes}>
                                    <img
                                        src={favBtn}
                                        alt="Likes"
                                        className={styles.likesIcon}
                                    />

                                    <span className={styles.likesCount}>
                                        {product.likes_count || 0}
                                    </span>
                                </div>

                            </div>


                        </div>

                    </div>
                );
            })}

        </main>
    );
}

export default AdminProductList;